import { defineMessages } from 'react-intl';

const messages = defineMessages({
  customer_name: '主要客户',
  case_digest: '服务案例(简举)',
  netease_case_digest: '网易游戏案例简举',
  total_employee: '公司人数',
  recommend_group_id: '推荐项目组',
  recommend_group_name: '推荐项目组',
  referrer_id: '推荐人',
  referrer_name: '推荐人',
  recommend_reason: '推荐入库理由',
});

export default messages;
